// extracted by mini-css-extract-plugin
export default {"ring":"SpinnerLoader_ring__YXH5h","rotate":"SpinnerLoader_rotate__inyLK","stretch":"SpinnerLoader_stretch__HQgU9"};